// extracted by mini-css-extract-plugin
export default {"root":"Options_root__L9owk"};